import { animate, inView } from "vendor";
/* ─── marquee-text ──────────────────────────────────────────────────── */
var MarqueeText = class extends HTMLElement {
  #currentAnimation;
  constructor() {
    super();
    inView(this, this.#initialize.bind(this), { margin: "400px" });
    if (this.hasAttribute("pause-on-hover")) {
      this.addEventListener("pointerenter", () => this.#currentAnimation?.pause());
      this.addEventListener("pointerleave", () => this.#currentAnimation?.play());
    }
  }
  get #direction() {
    return this.getAttribute("direction") === "right" ? 1 : -1;
  }
  get #scroller() {
    return this.shadowRoot.querySelector('[part="scroller"]');
  }
  #initialize() {
    if (this.children[0]?.childElementCount === 0) {
      return;
    }
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
        <slot part="scroller"></slot>
      `));
    const fragment = document.createDocumentFragment();
    const duplicateCount = Math.ceil(this.clientWidth / this.firstElementChild.clientWidth);
    for (let i = 1; i <= duplicateCount; ++i) {
      for (let y = 0; y < 2; ++y) {
        const node = this.firstElementChild.cloneNode(true);
        const value = 100 * i * (y % 2 === 0 ? -1 : 1);
        node.setAttribute("aria-hidden", "true");
        node.style.cssText = `position: absolute; inset-inline-start: calc(${value}%);`;
        fragment.appendChild(node);
      }
    }
    this.append(fragment);
    this.#currentAnimation = animate(this.#scroller, { transform: ["translateX(0)", `translateX(calc(var(--transform-logical-flip) * ${this.#direction * 100}%))`] }, {
      duration: 1 / parseFloat(this.getAttribute("speed")) * (this.#scroller.clientWidth / 300),
      easing: "linear",
      repeat: Infinity
    });
  }
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}
